import type { SVGProps } from 'react';
const SvgPanorama = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#panorama_svg__a)">
      <path
        fill="currentColor"
        d="M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2ZM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5Z"
      />
    </g>
    <defs>
      <clipPath id="panorama_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPanorama;
